// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiftref-inputs-group,
fieldset {
    display: flex;
    flex-direction: column;
    width: fit-content;
}
.swiftref-inputs-group-label {
    color: var(--text-default);
    font-family: var(--p1-regular-font-family);
    font-size: var(--p1-regular-font-size);
    line-height: var(--p1-regular-line-height);
    font-weight: var(--p1-regular-font-weight);
    margin-bottom: var(--spacing-05);
}


:host([alignment="horizontal"]) .swiftref-inputs-group,
:host([alignment="horizontal"]) fieldset {
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
}
:host([alignment="horizontal"]) fieldset {
    gap: var(--spacing-20);
}
:host([alignment="horizontal"]) .swiftref-inputs-group-label {
    flex: 1 0 100%;
    /*margin-bottom: 0;*/
}
:host([alignment="horizontal"]) swiftref-checkbox {
    margin-right: var(--spacing-20);
    margin-bottom: 0;
}

:host(:not([message])) swiftref-message {
    margin-top: 0;
    display: none;
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/form/inputs_group/style/index.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,0BAA0B;IAC1B,0CAA0C;IAC1C,sCAAsC;IACtC,0CAA0C;IAC1C,0CAA0C;IAC1C,gCAAgC;AACpC;;;AAGA;;IAEI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB","sourcesContent":[".swiftref-inputs-group,\nfieldset {\n    display: flex;\n    flex-direction: column;\n    width: fit-content;\n}\n.swiftref-inputs-group-label {\n    color: var(--text-default);\n    font-family: var(--p1-regular-font-family);\n    font-size: var(--p1-regular-font-size);\n    line-height: var(--p1-regular-line-height);\n    font-weight: var(--p1-regular-font-weight);\n    margin-bottom: var(--spacing-05);\n}\n\n\n:host([alignment=\"horizontal\"]) .swiftref-inputs-group,\n:host([alignment=\"horizontal\"]) fieldset {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: wrap;\n}\n:host([alignment=\"horizontal\"]) fieldset {\n    gap: var(--spacing-20);\n}\n:host([alignment=\"horizontal\"]) .swiftref-inputs-group-label {\n    flex: 1 0 100%;\n    /*margin-bottom: 0;*/\n}\n:host([alignment=\"horizontal\"]) swiftref-checkbox {\n    margin-right: var(--spacing-20);\n    margin-bottom: 0;\n}\n\n:host(:not([message])) swiftref-message {\n    margin-top: 0;\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
